import { storeTokens } from '@/lib/auth';

/**
 * Parses OAuth tokens from the URL hash fragment after Google SSO redirect.
 * The API redirects to /dashboard#accessToken=...&idToken=...&refreshToken=...&expiresIn=...
 * This extracts tokens synchronously, stores in localStorage, and cleans up the URL.
 *
 * Must be called before any auth checks so tokens are available in localStorage.
 */
export function processOAuthRedirect(): void {
  const hash = window.location.hash;
  if (!hash || hash.length < 2) return;

  const params = new URLSearchParams(hash.substring(1));
  const accessToken = params.get('accessToken');
  const idToken = params.get('idToken');

  if (!accessToken || !idToken) return;

  const refreshToken = params.get('refreshToken');
  const expiresIn = params.get('expiresIn');

  storeTokens({
    success: true,
    accessToken,
    idToken,
    refreshToken: refreshToken || undefined,
    expiresIn: expiresIn ? parseInt(expiresIn, 10) : undefined,
  });

  // Signal to AuthCacheInitializer that fresh OAuth tokens are present so it can
  // invalidate any stale null user entry in the persisted React Query cache.
  sessionStorage.setItem('yeschef_oauth_redirect', '1');

  // Clean the hash from the URL without triggering a navigation
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
}
